import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { Alert, Chip, Stack } from '@mui/material';
import { Public } from '@mui/icons-material';
import { selectIsCityAdmin, selectStaffZoneIds, selectUser } from '../../store/slices/authSlice';
import { listZones } from '../../services/zoneService';

export default function ZoneScopeBar() {
  const user = useSelector(selectUser);
  const isCityAdmin = useSelector(selectIsCityAdmin);
  const staffZoneIds = useSelector(selectStaffZoneIds);

  const { data: zonesData } = useQuery({
    queryKey: ['zones-scope-bar', staffZoneIds.join(',')],
    queryFn: () => listZones({ limit: 200 }),
    enabled: staffZoneIds.length > 0,
  });

  const zoneLabels = useMemo(() => {
    const zones = zonesData?.rows || [];
    return staffZoneIds.map((id) => {
      const z = zones.find((row) => row._id === id);
      return z ? `${z.name} (${z.code})` : id;
    });
  }, [staffZoneIds, zonesData?.rows]);

  if (!user || user.userType === 'super_admin' || user.userType === 'client_admin') return null;
  if (!staffZoneIds.length) return null;

  return (
    <Alert
      severity="info"
      icon={<Public fontSize="small" />}
      sx={{ mb: 2, borderRadius: 2, py: 0.75 }}
    >
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
        <span>{isCityAdmin ? 'City admin scope — managing:' : 'Your operating zones:'}</span>
        {zoneLabels.map((label) => (
          <Chip key={label} size="small" label={label} color="primary" variant="outlined" />
        ))}
      </Stack>
    </Alert>
  );
}
